import { useEffect, useState } from "react";
import MapInput from "./components/MapInput";
import { Button, Spinner } from "react-bootstrap";
import { apiUrls } from "../config/apiUrls.const";
import { _get } from "../services/apiClient";
import eventBus from "../utils/EventBus";
import { getStoredInfo } from "../utils/LocalStorageManager";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useClient } from "../contexts/ClientContext";

export default function Webpage() {
  const { biz_code } = useParams<{ biz_code: string }>();
  let navigate = useNavigate();
  const [bizInfo, setBizInfo] = useState<any | null>(null);

  const { setClient } = useClient();
  
  const [spaData, setSpaData] = useState<any[] | null>(null);
  const [parlorData, setParlorData] = useState<any[] | null>(null);
  const [salonData, setSalonData] = useState<any[] | null>(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchCategorizedItems();
  }, [biz_code]);

  // --------------------------------------------------
  // FETCH DATA
  // --------------------------------------------------
  const fetchCategorizedItems = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await _get(apiUrls.clientItems, {
        biz_code: biz_code,
      });

      const data = response?.data?.data;
      const businessInfo = data?.business || {};
      const serviceItems = data?.service_items || [];

      console.log(businessInfo)

      setClient({
        biz_code,
        title: businessInfo?.name,
        logo: businessInfo?.logo_path,
      });

      setParlorData(serviceItems?.parlor || []);
      setSpaData(serviceItems?.spa || []);
      setSalonData(serviceItems?.salon || []);
    } catch (err) {
      setError("Failed to fetch categorized items");
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------------------
  // NAVIGATE TO DETAILS
  // --------------------------------------------------
  const handleItemClick = (itemId: any) => {
    navigate(`/service-details?id=${itemId}`);
  };

  const businessPage = (bizCode: string) => {
    console.log(bizCode)
    navigate(`/webpage/${bizCode}`);
  }

  // --------------------------------------------------
  // LOADING STATE
  // --------------------------------------------------
  if (loading)
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p>Loading Services...</p>
      </div>
    );

  // --------------------------------------------------
  // ERROR STATE
  // --------------------------------------------------
  if (error)
    return (
      <div className="alert alert-danger text-center">
        {error} <br />
        <Button size="sm" onClick={fetchCategorizedItems}>
          Retry
        </Button>
      </div>
    );

  // --------------------------------------------------
  // REUSABLE SERVICE SECTION COMPONENT
  // --------------------------------------------------
  const ServiceSection = ({
    title,
    items,
  }: {
    title: string;
    items: any[] | null;
  }) => (
    <div className="row mb-5">
      <div className="col-12 mb-3">
        <h4>{title}</h4>
      </div>

      <div className="col-12">
        {items && items.length > 0 ? (
          <div className="row">
            {items.map((item) => (
              <div
                key={item.id}
                className="col-xl-4 col-lg-4 col-md-6 d-flex align-items-stretch"
              >
                <div className="item-box">
                  <img
                    src={item?.default_image?.image_url || "assets/img/saloon-2.jpg"}
                    className="img-fluid img-thumbnail item-img pointer"
                    alt={item.title}
                  />

                  <div className="title-info-box">
                    <h5
                      className="item-title pointer"
                      onClick={() => handleItemClick(item.id)}
                    >
                      {item.title}
                    </h5>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="item-info text-secondary fw-500">
                        <div className="row">
                          <div className="col">
                            <div className="mb-1 mt-1">
                              <i className="bi bi-clock-fill text-success"></i>{" "}
                              <span className="fw-500">{item.duration}</span>
                            </div>
                          </div>
                          <div className="col">
                            <div className="mb-1">
                              <b className="fs-120 text-primary">৳</b>{" "}
                              <span className="fw-500">{item.price} BDT</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No {title.toLowerCase()} available.</p>
        )}
      </div>
    </div>
  );

  // --------------------------------------------------
  // PAGE UI
  // --------------------------------------------------
  return (
    <>
      {parlorData && parlorData.length > 0 && (
        <ServiceSection title="Parlor Services" items={parlorData} />
      )}
      {spaData && spaData.length > 0 && (
        <ServiceSection title="Spa Services" items={spaData} />
      )}
      {salonData && salonData.length > 0 && (
        <ServiceSection title="Salon Services" items={salonData} />
      )}
    </>
  );
}
